(() => {
  const nodes: NodeListOf<HTMLInputElement> = document.querySelectorAll('.top-navigation__main-menu__item--search input');
  Array.prototype.forEach.call(nodes, (element: HTMLInputElement) => {
    const item: string = element.dataset.focus;
    const focusElement: HTMLElement = document.getElementById(item);

    if (focusElement === null) {
      return;
    }

    element.addEventListener('change', () => {
      setTimeout(() => { focusElement.focus(); }, 10);
    });
  });
})();
